<style>
    #product {
        height: calc(100vh - 128px) !important;
        /* padding: 30px 30px 8px 30px; */
    }

    #product .q-tab__label {
        font-size: 1rem;
        font-weight: bold;
    }

    #product .q-tab-panels {
        height: calc(100% - 48px) !important;
    }

    #product .q-table__middle {
        overflow-y: hidden !important;
        overflow-x: auto !important;
        height: calc(100% - 48px) !important;
        width: 100%;
    }

    #product .q-table { /*-horizontal-separator*/
        overflow: hidden !important;
        height: 100% !important;
        width: 100%;
    }

    #product .q-table thead {
        height: 48px;
        display: block;
    }

    #product tbody {
        display: block;
        height: 100%;
	    max-height: calc(100vh - 300px);;
        width: 100%;
        overflow: auto;
        webkit-overflow-scrolling: touch;
        will-change: scroll-position;
    }

    #product .q-table thead tr, #product .q-table tbody tr {
        width: 100%;
        display: table;
    }

    #product .q-table__bottom {
        position: absolute;
        bottom: 0;
        width: 100%;
    }
</style>
<template>
    <q-page id="product" padding :style="{padding:screenType?'30px 30px 8px 30px!important':'8px'}">
        <q-card class="fit">
            <!-- 关键词查询 -->
            <q-card-section style="height: 60px;padding:10px 15px;">
                <q-input v-model="keyword" @keyup.enter="getData(1)" :placeholder="$t('key')" maxlength="15"
                         style="width:210px;float:right;" rounded outlined dense>
                    <template v-slot:after>
                        <q-btn @click="getData(1)" icon="fa fa-search" color="white" text-color="primary" round dense/>
                    </template>
                </q-input>
            </q-card-section>
            <q-separator/>

            <!-- 混合媒体列表信息 -->
            <q-card-section class="q-pa-none" style="height:calc(100% - 60px);">
                <q-table class="fit" :data="listData" :columns="columns" :loading="loading" :pagination.sync="page"
                         :rows-per-page-options="[15,20,30]" row-key="id">
                    <tr slot="header" slot-scope="props">
                        <q-th key="id" :props="props" style="width:7%;min-width: 50px">ID</q-th>
                        <q-th key="name" :props="props" style="width:25%;min-width: 150px">{{$t('complexMedia.name')}}</q-th>
                        <q-th key="serverName" :props="props" style="width:25%;min-width: 150px">{{$t('complexMedia.msServiceId')}}
                        </q-th>
                        <q-th key="complexId" :props="props" style="width:25%;min-width: 150px">{{$t('complexMedia.complexId')}}</q-th>
                        <q-th key="createTime" :props="props" style="width:25%;min-width: 150px">{{$t('createTime')}}</q-th>
                        <q-th key="opt" :props="props" style="width:18%;min-width:135px;">{{$t('opt')}}</q-th>
                    </tr>
                    <q-tr slot="body" slot-scope="props" :props="props">
                        <q-td key="id" :props="props" style="width:7%;min-width: 61px">{{ props.row.id }}</q-td>
                        <q-td key="name" :props="props" style="width:25%;min-width: 150px">{{ props.row.name }}</q-td>
                        <q-td key="serverName" :props="props" style="width:25%;min-width: 150px">{{ props.row.serverName }}</q-td>
                        <q-td key="complexId" :props="props" style="width:25%;min-width: 150px">{{props.row.complexId }}</q-td>
                        <q-td key="createTime" :props="props" style="width:25%;min-width: 150px">{{props.row.createTime|parseDateTime
                            }}
                        </q-td>
                        <q-td key="opt" :props="props" style="width:18%;min-width:135px;">
                            <q-btn @click="btnClick(2,props.rowIndex)"
                                   :icon="props.row.msServerId?'fa fa-user-times':'fa fa-user-plus'" :color="'amber-7'"
                                   size="sm" round dense class="q-ml-sm">
                                <q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">
                                    {{$t('complexMedia.dialog[2]')}}
                                </q-tooltip>
                            </q-btn>
                            <q-btn @click="btnClick(1,props.rowIndex)"
                                   :color="'indigo-6'"
                                   icon="fa fa-user"
                                   size="sm" round dense class="q-ml-sm">
                                <q-tooltip :offset="[5,5]" anchor="top middle" self="bottom middle">
                                    {{$t('complexMedia.dialog[1]')}}
                                </q-tooltip>
                            </q-btn>
                        </q-td>
                    </q-tr>
                    <div slot="pagination" slot-scope="props" class="row flex-center q-py-sm">
                        <q-btn @click="pageClick(0)" :disable="curPage<=1" icon="fas fa-arrow-left" color="primary"
                               size="sm" round dense/>
                        <div class="q-mx-md" style="font-size: small"> {{ curPage }} / {{ totalPage }}</div>
                        <q-btn @click="pageClick(1)" :disable="nextPage" icon="fas fa-arrow-right" color="primary"
                               size="sm" round dense/>
                    </div>
                </q-table>
            </q-card-section>
        </q-card>

        <!-- 分配混合媒体信息 -->
        <q-dialog v-model="dialogStatus" persistent transition-show="scale" transition-hide="scale">
            <q-card  :class="[screenType?'q-pa-lg':'q-pa-sm']" :style="{minWidth:screenType?'450px':'85vw',width:screenType?'':'65vw'}">
                <q-card-section>
                    <div class="text-h6">{{$t('complexMedia.dialog')[dialogType]}}</div>
                </q-card-section>
                <q-card-section class="fit" style="max-height:60vh;height: 54vh;">
                    <div v-if="dialogType===2">
                        <q-select ref="customer" v-model="form.customer" :label="$t('customer.dialog[3]')"
                                  option-value="id" option-label="customerName" :options="customerOpt" emit-value
                                  map-options outlined
                                  :rules="[val => !!val || $t('msg.select'),]" input-debounce="0"/>
                    </div>

                    <div v-if="dialogType===1">
                        <q-list v-if="customerList&&customerList.length>0" bordered separator class="rounded-borders"
                                style="min-width:400px;overflow-x:auto;">
                            <q-item v-for="(item,index) in customerList" :key="index" class="q-py-md" clickable>
                                <q-item-section class="col-10">
                                    <q-item-label class="text-weight-medium">
                                        {{item.customerName}}
                                    </q-item-label>
                                </q-item-section>
                                <q-item-section>
                                    <div style="float: right" class="text-grey-8 q-gutter-xs">
                                        <q-btn @click="btnClick(3,index)"
                                               size="14px" flat dense round icon="fas fa-trash-alt" color="red"/>
                                    </div>
                                </q-item-section>
                            </q-item>
                        </q-list>
                        <div v-else>{{$t('null')}}</div>
                    </div>
                </q-card-section>
                <q-card-actions align="right" class="bg-white text-teal">
                    <q-btn :label="$t('close')" :flat="dialogType===2" color="primary" class="q-mr-md" v-close-popup/>
                    <q-btn v-if="dialogType===2" @click="confirm()" :label="$t('ok')" :disable="btnDisable"
                           icon="fas fa-check" color="primary"/>
                </q-card-actions>
            </q-card>
        </q-dialog>

    </q-page>
</template>
<script>
    export default {
        data() {
            return {
                keyword: null,
                color1: COLOR_Q,
                colors: COLOR_THEME,
                //loadIcon:[], loadData:[],
                filter: '',
                selected: 0,
                total: 0,
                curPage: 1,
                page: {page: 1, rowsPerPage: 20},
                loading: false,
                columns: [{name: 'id', field: 'id', align: 'left', sortable: true},
                    {name: 'name', field: 'name', align: 'left'},
                    //{ name: 'module', field: 'module', align: 'left', sortable: true },
                    {name: 'serverName', field: 'serverName', align: 'left', sortable: true},
                    {name: 'ser', field: 'msServerId', align: 'left', sortable: true},
                    {name: 'complexId', field: 'complexId', align: 'left',},
                    {name: 'createTime', field: 'createTime', align: 'left',},
                    {name: 'opt', field: 'opt', align: 'left'},
                ],
                data: ['广告屏', '灯杆'],
                listData: [],
                customerOpt: [],
                dialogStatus: false,
                dialogType: 0,
                content: {customer: null,},
                form: {},
                btnDisable: false,
                customerList: []
            }
        },
        props: ['lang'],
        filters: {
            parseDateTime(time) {
                return time ? parseDateTime(time) : time;
            }
        },
        watch: {
            lang(val, oldVal) {
                this.columns = this.columns;
            },
            pageCount(val, oldVal) {//选每页数量 size
                if (val) {
                    this.curPage = 1;
                    this.getData(this.curPage);
                }
            },
        },
        computed: {
            			screenType() {
      return _isPC(); //this.$q.platform.is.desktop
    },
            nextPage() {
                return this.curPage >= Math.ceil(this.total / this.page.rowsPerPage);
            },
            totalPage() {
                return Math.ceil(this.total / this.page.rowsPerPage);
            },
            pageCount() {
                return this.page.rowsPerPage;
            }
        },
        created() {
            this.form = JSON.parse(JSON.stringify(this.content));
            if (localStorage.getItem("AS_token") && localStorage.getItem("AS_token").length > 0) {
                this.getCustomer();
                this.getData(1);
            } else {
                this.$router.replace('/');//login
            }
        },
        methods: {
            openDialog(type,complexMediaId) {
                this.dialogType = type;
                if(type===1) {
                    console.log('混合媒体编号：', complexMediaId);
                    this.getCustomerByComplexId(complexMediaId);
                } else {
                    this.dialogStatus = true;
                }

            },
            // 获取已经分配的客户的信息 complexMedia
            getCustomerByComplexId(complexMediaId) {
                var request = {};
                request.complexMediaId = complexMediaId;
                request.paging = {index: 0, count: -1, sort: 'desc'};
                this.$ajax(1, 'post', true, '/complexMedia/customerIdInfo', request).then((res) => {
                    if (res && res.data) {
                        this.customerList = res.data
                        this.dialogStatus = true;
                        console.log(res.data)
                    }
                }).catch((err) => {
                    console.log(err)
                    this.$emit('islogin', 0, err);
                })
            },
            // 查询系统洪客户信息
            getCustomer() {
                var request = {};
                request.paging = {index: 0, count: -1, sort: 'desc'};
                this.$ajax(1, 'post', true, '/customer/list', request).then((res) => {
                    if (res && res.data) {
                        this.customerOpt = res.data;
                    }
                }).catch((err) => {
                    console.log(err)
                    this.$emit('islogin', 0, err);
                })
            },
            // 混合媒体列表
            getData(index) {
                this.listData = [];
                this.loading = true;
                var request = {};
                //request.ids = [];
                if (this.keyword) request.keyword = this.keyword;
                request.paging = {
                    index: (index - 1) * this.page.rowsPerPage,
                    count: this.page.rowsPerPage,
                    sort: 'desc'
                };
                this.$ajax(1, 'post', true, '/complexMedia/list', request).then((res) => {
                    if (res && res.data) {
                        this.listData = res.data;
                        this.total = res.paging.total;
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 800);
                }).catch((err) => {
                    console.log(err)
                    setTimeout(() => {
                        this.loading = false
                    }, 800);
                    this.$emit('islogin', index == 1 ? 0 : 1, err);
                    //if(err.code) this.$notify(2,err.msg,null);
                })
            },

            btnClick(type, index) {
                var _this = this
                if (type === 0 || type === 1) {
                    const complexMedia = this.listData[index];
                    this.openDialog(type,complexMedia.id);
                } else if (type === 2) {//分配
                    this.form = JSON.parse(JSON.stringify(this.listData[index]));
                    this.openDialog(type,-1);
                } else if (type === 3) {//移除分配
                    const customerMediaInfo = this.customerList[index]
                    console.log(this.customerList[index])
                    this.$ajax(1, 'delete', true, '/complexMedia/'+customerMediaInfo.customerId+'/'+customerMediaInfo.complexId, null).then((res) => {
                        //if(res.data) {
                        _this.getCustomerByComplexId(customerMediaInfo.complexId);
                        this.$notify(1, this.$t('product.ok_remove'), null);
                        //}
                    }).catch((err) => {
                        console.log(err)
                        this.$emit('islogin', 1, err);
                    })
                }
            },
            // 分配混合媒体
            confirm() {
                if (this.dialogType == 2) {
                    this.$refs.customer.validate();
                    if (this.$refs.customer.hasError) {
                        this.$notify(2, this.$t('msg.input_err'), null);
                        return
                    } else {
                        this.btnDisable = true;
                        var request = {};
                        request.complexIds = [this.form.id];
                        request.customerId = this.form.customer;
                        this.$ajax(1, 'post', true, '/complexMedia', request).then((res) => {
                            this.getData(this.curPage);
                            this.dialogStatus = false;
                            this.btnDisable = false;
                            this.$notify(1, this.$t('product.ok_assgin'), null);
                        }).catch((err) => {
                            console.log(err)
                            this.$emit('islogin', 1, err);
                            this.btnDisable = false;
                            //if(err.code) this.$notify(2,err.msg,null);
                        })
                    }
                }
            },
            pageClick(type) {//点击页数 type:0-,1+
                this.curPage = type ? this.curPage + 1 : this.curPage - 1;
                if (this.curPage > 0 && this.total !== 0 && this.listData.length < this.total) {
                    this.getData(this.curPage);
                }
            },
        }
    }
</script>
